(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".concern-grid--item__swiper");

    if (!slider) return;

    const columns = Number(slider.dataset.columns);
    const columnsConfig = {
      4: {
        750: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
        1360: { slidesPerView: 4 },
      },
      3: {
        750: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
      2: {
        750: { slidesPerView: 2 },
      },
      1: {
        576: { slidesPerView: 1 },
      },
    };

    const testimonialsSwiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
          nextEl: section.querySelector('.cards-grid__navigation-button-next'),
          prevEl: section.querySelector('.cards-grid__navigation-button-prev'),
          disabledClass: "swiper-button-disabled",
        },
      breakpoints: columnsConfig[columns],
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
